export default function isFunction(arg) {
  return arg && typeof arg === 'function';
}
